import { render } from "./UserUpdatePassword.vue?vue&type=template&id=86000b4e"
import script from "./UserUpdatePassword.vue?vue&type=script&lang=js"
export * from "./UserUpdatePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__